<template>
  <div>
    <div
      v-for="phone in inputFields"
      :key="phone.id"
      class="mt-3"
    >
      <v-text-field
        v-model="modelPhones[phone.id]"
        v-validate="validationRules.get('phone')"
        class="required-field"
        :mask="phone.mask"
        :error-messages="errors.collect(phone.error)"
        :label="$t('label.phone')"
        :data-vv-name="phone.error"
        :data-vv-as="$t('label.phone')"
        required
        inputmode="tel"
      />
    </div>
    <p class="mb-3 negative-margin-top">
      {{ $t('helps.help_phone') }}
    </p>
    <v-layout
      align-center
      justify-space-between
    >
      <a
        class="link_iconed small"
        :disabled="inputFields.length >= maxPhones"
        @click="addInputField"
      >
        <v-icon>add</v-icon>
        {{ $t('buttons.add_phone') }}
      </a>
      <a
        :disabled="inputFields.length <= 1"
        class="d-inline-flex"
        @click="removeInputField"
      >
        <baseIcon
          :width="16"
          :height="16"
        >
          <cartIcon :icon-color="$vuetify.theme.sz_violet" />
        </baseIcon>
      </a>
    </v-layout>
  </div>
</template>

<script>
import config from '@/constants/familyForm';
import validationRules from '@/constants/validationRules';
import phoneMask from '@/utils/phoneMask';
import baseIcon from '@/icons/BaseIcon';
import cartIcon from '@/icons/CartIcon';

export default {
    name: 'MultiplePhoneInput',
    components: {
        baseIcon,
        cartIcon
    },
    inject: ['$validator'],
    props: ['value'],
    data () {
        return {
            maxPhones: config.MAX_PHONE_INPUT_FIELD,
            modelPhones: [],
            inputFields: [{ id: 0, error: 'phone0', mask: '### ### ###' }],
            validationRules
        };
    },
    computed: {
        clearMultiplePhone () {
            return this.$store.getters['familyData/getClearMultiplePhone'];
        }
    },
    watch: {
        modelPhones: {
            handler: function (newPhones) {
                this.$emit('input', this.getNumbers());

                this.updateMultipleFieldMask(newPhones);
            },
            deep: false
        },
        clearMultiplePhone: {
            handler (val) {
                if (val) {
                    this.clear();
                }
            }
        }
    },
    created () {
        this.updateField();
    },
    methods: {
        clear () {
            this.modelPhones = [];
            this.inputFields = [{ id: 0, error: 'phone0', mask: '### ### ###' }];
            this.$emit('input', []);
        },
        addInputField () {
            if (this.inputFields.length < this.maxPhones) {
                this.inputFields.push({
                    id: this.inputFields.length,
                    error: 'phone' + this.inputFields.length,
                    mask: '### ### ###'
                });
            }
        },
        removeInputField () {
            if (this.inputFields.length > 1) {
                if (this.inputFields.length === this.modelPhones.length) {
                    this.modelPhones.pop();
                }
                this.inputFields.pop();
            }
        },
        getNumbers () {
            const num = [];
            this.modelPhones
                .filter((el) => {
                    return el.length > 0;
                })
                .forEach((el) => {
                    num.push({ number: el });
                });
            return num;
        },
        updateMultipleFieldMask (values) {
            for (let i = 0; i < values.length; i++) {
                const field = this.inputFields.find((field) => {
                    return field.id === i;
                });
                if (field) {
                    field.mask = phoneMask(values[i]);
                }
            }
        },
        updateField () {
            if (Array.isArray(this.value) && this.value.length > 0) {
                this.value.forEach((el) => {
                    this.modelPhones.push(el.number);
                });
                if (this.inputFields.length < this.value.length) {
                    const _l = this.value.length - this.inputFields.length;
                    for (let i = 0; i < _l; i++) {
                        this.inputFields.push({
                            id: this.inputFields.length,
                            error: 'phone' + this.inputFields.length,
                            mask: '### ### ###'
                        });
                    }
                }
            }
        }
    }
};
</script>

<style scoped>
.v-input {
  padding: 10px 0;
}
.theme--light.v-btn {
  width: 70px;
  min-width: 70px;
}
</style>
